module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["老师(" + _vm._s(_vm.teacherList.length) + ")"]), " ", _vm._h('router-link', {
    staticClass: "pull-right icon-right icon-setup text-hide",
    attrs: {
      "to": {
        path: '/invitation/teacher'
      },
      "tag": "span"
    }
  }, ["更多"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._l((_vm.teacherList), function(item) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": {
          path: '/teacher/detail/' + item.teacherId
        }
      }
    }, [_vm._h('div', {
      staticClass: "img-wrap pull-left small"
    }, [_vm._h('img', {
      attrs: {
        "src": item.teacherIcon ? (item.baseAcessPath + item.teacherIcon) : _vm.img_default
      }
    })]), " ", _vm._h('span', {
      staticClass: "group-txt"
    }, [_vm._h('span', {
      staticClass: "block clearfix"
    }, [_vm._h('cite', {
      staticClass: "font-16 pull-left"
    }, [_vm._s(item.teacherName)]), " ", " ", " ", _vm._h('span', {
      staticClass: "gray margin-x-15 font-12 pull-right"
    }, [_vm._s(item.jobName)])]), " ", _vm._h('cite', {
      staticClass: "gray hide"
    }, [_vm._s(item.phoneNum)])])])])
  })]), " ", _vm._h('ul', {
    staticClass: "bg-white"
  }, [_vm._h('li', [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "font-12",
    staticStyle: {
      "padding": "15px 10px"
    }
  }, [_vm._h('p', {
    staticClass: " font-16 margin-15"
  }, ["*温馨提示"]), " ", _vm._h('p', {
    staticClass: "gray margin-15"
  }, ["管理员有添加或删除老师的权限。", _vm._h('br'), "超级管理员除了一般管理员权限外，可以将老师提升为管理员权限，也可以将管理员降为老师权限。", _vm._h('br'), "老师只有一般的管理权限。"]), " ", _vm._h('p', {
    staticClass: "gray margin-15"
  }), " ", _vm._h('p', {
    staticClass: "gray margin-15"
  })])])])])])]), " ", (_vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('div', {
    staticClass: "bottom-bar hide"
  }, [_vm._h('router-link', {
    staticClass: "button button-block button-primary",
    attrs: {
      "to": {
        path: '/teacher/add'
      }
    }
  }, ["添加老师"])]) : _vm._e(), " ", (_vm.cookie_login_data.jobId == 8 || _vm.cookie_login_data.jobId == 9 || _vm.cookie_login_data.jobId == 10 || _vm.cookie_login_data.jobId == 3) ? _vm._h('div', {
    staticClass: "bottom-bar hide"
  }, [_vm._h('a', {
    staticClass: "button button-block button-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toastShow('您没有添加权限')
      }
    }
  }, ["添加老师"])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-173bb632!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/teacher/TeacherManage.vue
// module id = 180
// module chunks = 1